module.exports = __webpack_public_path__ + "static/media/icon_unfold_wap.9ab0c5f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_unfold_wap.svg
// module id = 446
// module chunks = 0